"use client";
import { ReactNode, useEffect } from "react";
import { Provider, useDispatch } from "react-redux";
import { store } from "./index";
import { initialize } from "./customerSessionSlice";

// Internal component to initialize session after hydration
function Initializer({ children }: { children: ReactNode }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(initialize());
  }, [dispatch]);
  return <>{children}</>;
}

export function ReduxProvider({ children }: { children: ReactNode }) {
  return (
    <Provider store={store}>
      <Initializer>{children}</Initializer>
    </Provider>
  );
}
